export default function CollapseIcon() {
  return (    
    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="6" viewBox="0 0 10 6" fill="none">
        <path d="M9 5L5 1L1 5" strokeLinecap="round"/>
    </svg>
  );
}
